export const validateField = (fieldName, data, validationSchema) => {
    try {
        validationSchema.validateSyncAt(fieldName, data);
    }
    catch (e) {
        return e.errors;
    }
    return null;
};
